import BaseView from "./_BaseView";
import Api from "../Api";

export default class TipStyleView extends BaseView {
    save() {
        const data = $('#tipForm').aeroSerialize();
        if ($('#tipForm').isFormValid()) {
            Api.send('/api/savetip', data, 'post').done(function () {
                window.location = `/app/${$('[data-app]').data('app')}/config`;
            });
        }
    }

    previewEvents() {
        $('input[name="tip_title_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('.aero-tip-title')
                    .css({"background-color": input.val()});
            }
        });
        $('input[name="tip_title_fg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('.aero-tip-title')
                    .css({color: input.val()});
                $('.aero-customize-preview')
                    .find('.aero-tip-title a svg').css({fill: input.val()});
            }
        });
        $('input[name="tip_body_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .css({"background-color": input.val()});
            }
        });
        $('input[name="tip_body_fg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview, .aero-customize-preview .aero-tip-body, .aero-customize-preview .aero-tip-body p, .aero-customize-preview .aero-tip-body span')
                    .css({color: input.val()});
            }
        });
        $('input[name="tip_anchor"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview .aero-tip-body a')
                    .css({color: input.val()});
            }
        });
        $('input[name="tip_prev_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('.aero-tip-nav a.aero-btn-prev')
                    .css({"background-color": input.val()});
            }
        });
        $('input[name="tip_prev_fg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('.aero-tip-nav a.aero-btn-prev')
                    .css({color: input.val()});
            }
        });
        $('input[name="tip_next_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('.aero-tip-nav a.aero-btn-next')
                    .css({"background-color": input.val()});
            }
        });
        $('input[name="tip_next_fg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('.aero-tip-nav a.aero-btn-next')
                    .css({color: input.val()});
            }
        });
        $('input[name="tip_footer_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('.aero-tip-draggable')
                    .css({"background-color": input.val()});
            }
        });
        $('input[name="tip_footer_mb"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('.aero-tip-draggable svg g')
                    .css({fill: input.val()});
            }
        });
        $('input[name="quiz_unselected_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('label.unselected')
                    .css({background: input.val()});
            }
        });
        $('input[name="quiz_unselected_color"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('label.unselected')
                    .css({color: input.val()});
            }
        });
        $('input[name="quiz_selected_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('label.selected')
                    .css({background: input.val()});
            }
        });
        $('input[name="quiz_selected_color"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('label.selected')
                    .css({color: input.val()});
                $('.aero-customize-preview')
                    .find('label.selected:before')
                    .css({color: input.val(), borderColor: input.val()});
            }
        });
        $('input[name="quiz_wrong_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('label.recent-choice')
                    .css({background: input.val()});
            }
        });
        $('input[name="quiz_wrong_color"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('label.recent-choice')
                    .css({color: input.val()});
            }
        });
        $('input[name="quiz_correct_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('label.aero-quiz-pass')
                    .css({background: input.val()});
            }
        });
        $('input[name="quiz_correct_color"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('label.aero-quiz-pass')
                    .css({color: input.val()});
            }
        });
        $('input[name="quiz_submit_bg"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('a.aero-quiz-btn')
                    .css({background: input.val()});
            }
        });
        $('input[name="quiz_submit_color"]').off('change.colorprev').on('change.colorprev', function () {
            const input = $(this);
            if (input.is(':visible')) {
                $('.aero-customize-preview')
                    .find('a.aero-quiz-btn')
                    .css({color: input.val()});
            }
        });
    }

    resetDefaults() {
        // set values
        let values = DefaultTip;
        for (let x in values) {
            if (values.hasOwnProperty(x)) {
                $(`input[name="${x}"]`).val(values[x]);
            }
        }
        $('input[type="color"]').trigger('change.colorprev');
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const body = $('body');

        // set values
        if ($('#TipStyleScript').length > 0) {
            // globals from page
            // const values = typeof TipStyle !== 'undefined' ? TipStyle : DefaultTip;
            const values = $.extend(DefaultTip, typeof TipStyle !== 'undefined' ? TipStyle : {});
            for (let x in values) {
                if (values.hasOwnProperty(x)) {
                    $(`input[name="${x}"]`).val(values[x]);
                }
            }
        }

        this.previewEvents();
        $('input[type="color"]').trigger('change.colorprev');

        body.off('click.aeroresetcolors').on('click.aeroresetcolors', '.aero-customize-reset', function () {
            const index = parseInt($('select.aero-tip-customizer').val());
            self.resetDefaults(index);
            return false;
        });

        body.off('click.submitcolors').on('click.submitcolors', '.aero-btn-save-settings', function () {
            self.save();
            return false;
        });
    }
};
